document.addEventListener("DOMContentLoaded", function () {
  handleTabs();
});


function handleTabs() {
  const tabs = document.querySelectorAll('.mm-featured-collections-wrapper .tab-button');

  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      tabs.forEach(t => t.classList.remove('active'));

      const panes = document.querySelectorAll('.mm-tab-pane');
      panes.forEach(pane => pane.classList.remove('active'));

      this.classList.add('active');
      const target = document.getElementById(this.getAttribute('data-tab'));
      if (target) target.classList.add('active');
    });
  });
}